//cn.js

import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  message: {
    'veS_overall_s_pl': '请输入关键字',
  },
  // 统一错误信息处理
  error: {
    "9000G1001":"不能重复审核",
    "9000G1002":"生成Client失败",
    "9000G1003":"原始密码不正确",
    "9000G1004":"邮箱格式有误",
    "9000G1005":"不满足密码规则，字母和数字组合最少8个字符" ,
    "9000G1006":"两次密码不一致",
    "9000G1007":"邮箱已存在",
    "9000G1008":"验证码不正确",
    "9000G1009":"不能重复提交",
    "9000G1010":"只有未提交或审核失败的才能提交",
    "9000G1011":"手机号已存在"
  },
  ...zhLocale
}

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js